import { useEffect, useRef, useState } from "react";

const steps = [
    {
        number: "PASO #1",
        title: "Evaluamos tu caso",
        description:
            "Contamos con un amplio equipo de trabajo respaldados por el acompañamiento de nuestros abogados para evaluar tu caso totalmente gratis.",
    },
    {
        number: "PASO #2",
        title: "Te orientamos",
        description:
            "Te asesoramos según tu situación al proceso migratorio que se adapte y sea adecuado para ti.",
    },
    {
        number: "PASO #3",
        title: "Te acompañamos",
        description:
            "Tenemos un equipo con más de 400 personas altamente calificadas disponibles para que te acompañen de principio a fin durante tu proceso.",
    },
];

export default function Timeline() {
    const containerRef = useRef(null);
    const progressRef = useRef(null);
    const stepRefs = useRef([]);
    const [activeCount, setActiveCount] = useState(0);

    useEffect(() => {
        stepRefs.current = stepRefs.current.slice(0, steps.length);

        let rafId = null;

        const calcProgress = () => {
            const container = containerRef.current;
            if (!container) return;

            const containerRect = container.getBoundingClientRect();
            const containerTop = containerRect.top + window.scrollY;
            const containerHeight = containerRect.height || 1;
            const scrollMid = window.scrollY + window.innerHeight * 0.5;

            let ratio = (scrollMid - containerTop) / containerHeight;
            ratio = Math.max(0, Math.min(1, ratio));

            if (progressRef.current) {
                progressRef.current.style.height = `${ratio * 100}%`;
            }

            let count = 0;
            stepRefs.current.forEach((el, idx) => {
                if (!el) return;
                const r = el.getBoundingClientRect();
                const elMid = r.top + window.scrollY + r.height / 2;
                if (elMid <= scrollMid) {
                    el.classList.add("active");
                    count = idx + 1;
                } else {
                    el.classList.remove("active");
                }
            });

            setActiveCount(count);
        };

        const onScroll = () => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(calcProgress);
        };

        calcProgress();

        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll);

        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onScroll);
            if (rafId) cancelAnimationFrame(rafId);
        };
    }, []);

    return (
        <section className="timeline-section" ref={containerRef}>
            <div className="timeline-line">
                <div className="timeline-progress" ref={progressRef} />
            </div>

            {steps.map((step, index) => (
                <div
                    className="timeline-step"
                    key={index}
                    ref={(el) => (stepRefs.current[index] = el)}
                >
                    <div className="timeline-marker" />
                    <div className="timeline-content">
                        <span className="step-number">{step.number}</span>
                        <h3>{step.title}</h3>
                        <p>{step.description}</p>
                    </div>
                </div>
            ))}
        </section>
    );
}
